<template>
    <div>
        <hosting-settings v-if="isTechnicallyActive" :domain="domain" :subscription="subscription" />
        <div v-else class="page-block__item-wrapper">{{ trans('hosting.no-hosting') }}</div>
    </div>
</template>

<script>
import { HostingSettings } from 'relapp-hosting';

export default {
    components: {
        HostingSettings
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        subscription: {
            type: Object,
            required: true
        }
    },
    computed: {
        /**
         * Checks if the hosting subscription is technically active.
         *
         * @return {boolean}
         */
        isTechnicallyActive() {
            return this.subscription.technical_status === 'ok';
        }
    }
};
</script>
